import { getFirebaseAuth } from '@/utils/firebase/firebaseAuth'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const init = async (tenantId: string): Promise<any> => {
  // Import firebaseui.auth dynamically to avoid issues with SSR or window not being defined
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const firebaseui = require('firebaseui').auth

  // we create a new instance each time rather than re-using AuthUI.getInstance(), as an instance is tied down to a tenantID which may cause problems when switching tenants
  const existingInstance = firebaseui.AuthUI.getInstance()
  if (existingInstance) {
    await existingInstance.delete()
  }

  return new firebaseui.AuthUI(getFirebaseAuth(tenantId))
}
